/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HchbContactSummary
 */
export interface HchbContactSummary {
    /**
     * 
     * @type {string}
     * @memberof HchbContactSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof HchbContactSummary
     */
    contact_name: string;
    /**
     * 
     * @type {string}
     * @memberof HchbContactSummary
     */
    contact_type?: string;
}

/**
 * Check if a given object implements the HchbContactSummary interface.
 */
export function instanceOfHchbContactSummary(value: object): value is HchbContactSummary {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('contact_name' in value) || value['contact_name'] === undefined) return false;
    return true;
}

export function HchbContactSummaryFromJSON(json: any): HchbContactSummary {
    return HchbContactSummaryFromJSONTyped(json, false);
}

export function HchbContactSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbContactSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'contact_name': json['contact_name'],
        'contact_type': json['contact_type'] == null ? undefined : json['contact_type'],
    };
}

export function HchbContactSummaryToJSON(json: any): HchbContactSummary {
    return HchbContactSummaryToJSONTyped(json, false);
}

export function HchbContactSummaryToJSONTyped(value?: HchbContactSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'contact_name': value['contact_name'],
        'contact_type': value['contact_type'],
    };
}

